
import { apiClient } from '../client'

export interface UploadImageResponse {
    success: boolean
    filename: string
    url: string
}

export interface UploadFileResponse {
    success: boolean
    filename: string
    objectPath: string
    url: string
}

class UploadRepository {

    async uploadImage(file: File | Blob, folder: string = 'skus'): Promise<UploadImageResponse> {
        const formData = new FormData()
        formData.append('image', file)
        formData.append('folder', folder)

        return apiClient.post<UploadImageResponse>('/upload/image', formData)
    }

    async uploadFile(file: File | Blob, folder: string = 'user_attachments'): Promise<UploadFileResponse> {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('folder', folder)

        return apiClient.post<UploadFileResponse>('/upload/file', formData)
    }

    /**
     * Delete image from GCP via backend
     * @param filename - Filename in bucket
     */
    async deleteImage(filename: string): Promise<{ success: boolean; message: string }> {
        return apiClient.delete<{ success: boolean; message: string }>(`/upload/image/${encodeURIComponent(filename)}`)
    }

    async deleteFile(objectPath: string): Promise<{ success: boolean; message: string }> {
        return apiClient.delete<{ success: boolean; message: string }>(
            `/upload/file?path=${encodeURIComponent(objectPath)}`,
        )
    }
}

export const uploadRepository = new UploadRepository()

